export default __webpack_public_path__ + "static/media/27_cosmos.4ce8eb5e.JPG";